import React, { useEffect, useState } from "react";
import { getAllRooms } from "../../../../api/admin/hotel";

const SelectRooms = ({
  HotelId,
  SelectedRoom,
  setSelectedRoom,
  setSelectedRooms,
  setRoomsData,
  CheckIn,
  CheckOut,
  code,
}) => {
  const [Data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [Show, setShow] = useState(false);
  const [Search, setSearch] = useState("");
  useEffect(() => {
    if (HotelId) {
      getAllRooms(setData, HotelId);
    }
  }, [HotelId]);
  const handleShow = () => {
    setShow(!Show);
  };
  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(Data);
    } else {
      const result = Data.filter((item) =>
        item.roomName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }

    if (HotelId) {
      const selected = Data.find((item) => item.hotelId === HotelId);
      setSelectedRoom(selected);
    }
  }, [Search, Data, HotelId]);

  const handleSelect = (item) => {
    const roomId = item.id;
    const room = Data.find((r) => r.id === roomId);
    if (!room) return;
    setSelectedRooms((prev) => {
      const exists = prev.find((r) => r.id === room.id);

      let updatedRooms;

      if (exists) {
        updatedRooms = prev.filter((r) => r.id !== room.id);
      } else {
        updatedRooms = [...prev, room];
      }

      const formattedData = updatedRooms.map((r) => {
        const price = r.actualPrice || 0;
        const discount = r.discount || 0;

        const discountedPrice = price - (price * discount) / 100;
        const taxAmount = (discountedPrice * (r.tax || 0)) / 100;

        return {
          hotelId: HotelId,
          roomId: r.id,
          roomName: r.roomName,
          orderId: code || "",
          checkIn: CheckIn,
          checkOut: CheckOut,
          actualPrice: price,
          discount: discount,
          discountedPrice: discountedPrice,
          serviceCharge: r.tax || 0,
          serviceChargeAmount: taxAmount,
          paymentStatus: "Pending",
          paymentNature: "Online",
          requestedBy: "Hotel",
          isApproved: 1,
        };
      });

      setRoomsData(formattedData);
      setSelectedRoom(item);
      setShow(false);
      return updatedRooms;
    });
  };
  return (
    <div className="w-full relative">
      <div
        onClick={handleShow}
        className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm cursor-pointer select-none flex justify-start items-center gap-3 bg-white"
      >
        {SelectedRoom ? (
          <>
            <div className="flex gap-x-2 justify-start items-center">
              <p className="text-sm font-medium uppercase">
                {SelectedRoom.roomName}
              </p>
            </div>
          </>
        ) : (
          <div>
            <p>Select room</p>
          </div>
        )}
      </div>
      {Show && (
        <div className="bg-white w-full max-h-[300px] overflow-y-auto p-3 absolute top-10 drop-shadow-lg left-1/2 -translate-x-1/2 rounded-lg z-10 border scrollbar-hide">
          <div className="space-y-3">
            <div>
              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
                placeholder="Search room by name"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
            </div>
            <div>
              {filteredData.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => handleSelect(item)}
                    className="flex gap-2 justify-start items-center bg-white hover:bg-[#d7eaff] p-2 rounded-lg cursor-pointer"
                  >
                    <div className="flex gap-x-2 justify-start items-center">
                      <p className="text-sm font-medium uppercase">
                        {item.roomName}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectRooms;
